module.exports = __webpack_public_path__ + "img/org_logo.30af4d37.png";